/**
 * JSON.stringify() with a replacer that converts undefined values to a special string.
 */
export function stringifyWithReplacer(input: any): string {
    return JSON.stringify(input, replace);
}

/**
 * JSON.parse() with a reviver that converts ISO date strings back to Date objects and
 * replaces the special string __UNDEFINED__ back to undefined.
 */
export function parseWithReviver(input: string) {
    return reviveUndefined(JSON.parse(input, revive));
}

/**
 * replacer function for JSON.stringify() to convert undefined values to a special string.
 */
function replace(key: string, value: any) {
    return value === undefined ? '__UNDEFINED__' : value;
}

/**
 * JSON.parse() does not properly recreate Date objects by default.
 * This function is used as a reviver function to recreate Date objects from ISO strings.
 * It uses zurichDate() to create date-fns TZDate objects in the Zurich timezone.
 */
function revive(key: string, value: any) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[+-]\d{2}:\d{2}|Z$/.test(value)) {
        try {
            const date = zurichDate(value);
            return !Number.isNaN(date.getTime()) ? date : value;
        }
        catch (err) {}
    }
    return value;
}

/**
 *
 */
function reviveUndefined(object: any) {
    if (object && typeof object === 'object') {
        for (const k of Object.keys(object)) {
            if (object[k] === '__UNDEFINED__') {
                object[k] = undefined;
            }
            else {
                reviveUndefined(object[k]);
            }
        }
    }
    return object;
}
